import { clientConfig } from '@/config/clientConfig';
import { canRequestMoreInfo } from '@/domains/jobs/constants/canRequestMoreInfo';
import { Button } from '@/shared/ui/button';
import { ArrowUpRight, HelpCircle } from 'lucide-react';

interface RequestMoreInfoButtonProps {
  mirPendingDirection: 'inbound' | 'outbound' | null | undefined;
  /** Current work-order status; MIR is hidden on terminal states (Completed/Rejected/Cancelled/Validated). */
  workOrderStatus: string | null | undefined;
  onClick: () => void;
}

export function RequestMoreInfoButton({
  mirPendingDirection,
  workOrderStatus,
  onClick,
}: RequestMoreInfoButtonProps) {
  if (!clientConfig.features.requestMoreInfo) return null;

  // Terminal work orders (Completed/Rejected/Cancelled/Validated) can't raise or
  // reply to a MIR — mirror CORE, which hides "Provide Information" there.
  if (!canRequestMoreInfo(workOrderStatus ?? '')) return null;

  if (mirPendingDirection === 'outbound') {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/30 text-sm text-blue-700 dark:text-blue-300 whitespace-nowrap">
        <ArrowUpRight className="w-4 h-4 shrink-0" />
        Awaiting reply
      </div>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className="border-amber-600 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-950"
      onClick={onClick}
    >
      <HelpCircle className="w-4 h-4 mr-2" />
      {mirPendingDirection === 'inbound' ? 'Reply to Info Request' : 'Request More Info'}
    </Button>
  );
}
